export default __webpack_public_path__ + "static/media/category_12.69bfc558.png";